
export const BeeContracts = {
    'black': "0x7Bc2E3A31Cb25A4E0CbA7E12E651e617e43198e3", // test
    'golden': '0xa4f1bfDF8da3C0A9007C3DD132f4E922d602339E', // test
    'purple': ''
}

export const BaseUrl = {
  'black': "https://gateway.nutbox.app/ipns/k51qzi5uqu5dlep4q5te5cs4yxhco1ekfdgeuk4ppwidy3e5l5csgfoqdga96k/",
  'golden': "https://gateway.nutbox.app/ipns/k51qzi5uqu5dil44fz8dwqh84boop5moe5qojmifrx2036p7vloi2wmum7y68w/",
  'purple': ""
}

export const BlackBeeCANBaseUri = 'https://cdn.wherein.mobi/community/mferc/blackCAN/%24mferc_MMB_OG';

export const Description = {
    'black': `MCO(Mferc Community OG) is a functional NFT based on the ERC-721 protocol issued by Mferc Community.\n The total number of NFTs for sale is 66.\nNFT holders will have the corresponding features and benefits with Mferc Community.\nWhitelisting is required to mint.\nCategory PFPs. `,
    'purple': `MCB(Mferc Community Builder) is a functional NFT based on the ERC-721 protocol issued by Mferc Community.\n The total number of NFTs for sale is 666.\nNFT holders will have the corresponding features and benefits with Mferc Community.\nWhitelisting is required to mint.\nCategory PFPs. `,
    'golden': `MCM(Mferc Community Member) is a functional NFT based on the ERC-721 protocol issued by Mferc Community.\n The total number of NFTs for sale is 6666.\nNFT holders will have the corresponding features and benefits with Mferc Community.\nNo whitelist required, anyone can mint directly.\nCategory PFPs.`
  }

export const BlackUris = [
'QmWtBnfbXkwMKe5zs4i89fTthvKeNRzFXpn6eTmfnqczR8',
'QmfXsaZm8Pw3BapzUTAFzqgknW7YbC8ueBNL5kdyF624WT',
'QmaNN8bey5dqUwBNecZTinNSiFZrP1TSENJQfYUvrbESBa',
'QmZirPdC7Tfmonngg1ok3p3urrwpScLVPTVRFhqxmRhGUq',
'QmTZnK3EwCFUezseL6T9DjudKi3YUFehfGC9YDzp18iC4E',
'QmZdEWokHmAEsU3ypzvRTuEKut6cR1qYCTdjAGeadsb5vd',
'Qmds3qZVU8bLgDGeC7jAnooLtCL219afaVz3bXaFEW7CA8',
'QmWLHnWSv9yqypZPfxr3TDcsBpzKBVvKiJmNoZvyvrNFkB',
'QmQtyBNe9VRTaqH9p9fpvuYFhJC2Z2Q1WpXptnFbwAuHvq',
'QmQCysk9A2hwodTEPXQHAorx49neizJBw1n5qkHmezECRu',
'QmRYUGzaCkoEwSkANYHdwa8JgxtX5hgkiw18maaaeqDepc',
'QmRLahLZBxivzRJcqBgbi6D7st1FdVtHL7GksgE8WaHEeU',
'QmWBLC21t9Gn4yQ3RhAtAJCn57JnuSFZuozEkcb6gzrAa4',
'QmVWWBSQEyx47cU84aHDU6J4B3nLpzXi7SChStETdy5WxC',
'Qma6nsACB4619n2c8XCNmHmJikkAvKoPRLt34XGbWm8TRY',
'QmRV8yERQTC9Lkv3cCD8TJitwoGmZ1rL7wPvDRP89Gpw7X',
'QmZeYeXwPZahHrnBsiUGT4V1zzEJPDUSC5VMxJJAYG7Xgf',
'QmUDZMLqXqp6r9CJTaTjMChqpeZetcybBuQGY3nP5TseFJ',
'QmUiX9wyPbLcqbiNYvbfY3vQ3iw1CZRePemgZ5gbVzkiF2',
'QmevRKVmvaJTHARUVF2VjCGtqEMwQ4U7tiCNNM3UUHcRDh',
'QmVAn9wpAKwraJ7T2Kz9ympAS3Bd4kQKNzqxb2LpamNq52',
'QmVz8Qi8vpg7VYa7KTPQirS5Zd3comtTCnBMXwSayN6bWR',
'QmRAe1rsmAh9CYT3CY2n7XRXRX98TqMoXLDio8XCDbiXjB',
'QmQjVQeFK3MQxZkpK7Mnu21MhbekM4cspd4J5r7axxfMza',
'Qma1oFWD4wtVXEuPTH7DVER6zhYT899neNgHM93BiyinoL',
'QmUpmrZcidVcD7LUFX8DftnEzc5czEcYeEbnRV2E4BnFM9',
'QmZyjcuZWD8CTTZmbiJ6tTXn2yTEGVhimrdbg9ZNf35ZJY',
'QmRBLKtPzHyuSD2rTX4gj9RPsT9GAcBuvUQgZZUVy9xbNF',
'QmUX4DWvBFf8opfdM1x3s2YHBcWVeZLcR8VrFoPiakrCT4',
'QmTLk2WAQQ6fJoURGeZTFcttu9xiTJbDdDyt2ZHKKK2eWx',
'QmU9ihAjCou7xDDbAwvkGpvVeU9w6zfcjDfiChbu9PHmU7',
'QmfCHHrXCdQKofxDAf91XyrsBHzRnvNK2pda21V5Xu8b2w',
'QmZHoMMmCPg86eCBqBaQSsVyknB4Yty72f3eHgefFrAnSe',
'QmVoHsfmSg7VwgWpKGSBAP76PrTqCQEWcY5SCDFpJNUv3i',
'QmWVVce16aemqKDLnPr4UktdMsWoWRYxWfRi8Ue7FPXYdj',
'QmVQ8FKuoByMppcAXkeM2vGfeWPhhaks9CjZRdn25qDs6m',
'QmTCHw5k75Cz9ey8jgUdeznwhsJwkDK5puoH7msMUoTkiq',
'QmQBm83pbnaf5DxLKp4TuqWiE7SvJJM4Ca1pCY7WF5oDRU',
'QmcHVR25m9QTAAZ1LXKda9WKTyiqEynk8dwPiunu3mNDQq',
'QmPdnuvDNtgyHvAKqR2eMX91bYP61fhNUaARaobmFo5nLk',
'QmUk23SmKVojQrdpyJDVFuyMj2PDW4Y93uELX6NJMf9Uac',
'QmQJZsxUkRKmMQL1VpyS3jknuc7cHHmYWBBFE7RFJ4fNVJ',
'QmZvh4MNwqjeUQwrrfaNrzaWA6n3eTESGfDL9ytvh2Jiab',
'QmR3qmFG3xH6iPXBPuHdwGAN7ByFUHfV5KcwmJZk6kGccr',
'QmfJ1my8ka6jZnDQmzn5u86PvM81HQKxSRFwK2zr4ydTVd',
'QmW7bLF3BaweASu9dinMY1oFDnXqgWpA8cgDoWfSSao7f8',
'QmUhj5mkpQY8zD6DB31U5d7YKMFvoT9vgYxi9cnFHMjNr2',
'QmPpzGgVmoVeCoetoRSQpR4ButcrXUcP6DcWCCZPvNBrj9',
'QmYnzUe4DKvz6R7SBSBuaBLFBdw4qeJ2cKvK8ryS1d8bdZ',
'QmVj5vuA3yawhWRotZyyge67fSTui4zp1Hi7Q9pGzGzFTd',
'QmSYCXA5zKZ6s5uZsCJkty2qxmRK2ZVQkCZabByJaW1t5U',
'QmPasvsiaBJpG4E5qtAW6bhKXsp1TUKnhEfb2xTyNfH14w',
'QmTAEjXXBiScwuY7oPWm4GLBNWBXCXg9xgu5V7HayTcsW1',
'QmPcqtFg4KiUGZGgbYCUaFyzLP3hCvFpTEbk86FjmSwWDV',
'QmS3VVuENB5dsDn6LtfjQzvMjqSR7t8TTuB433kR9KAbim',
'QmUrCeUGJssmqhXSVL1hGBGoVFT564sB9SBB2Eq1D5VUHp',
'QmZRtRifa3EBf6h6gX9JFbNe9uD3dBub8VjJXgsuJRgq3Z',
'QmUA2X2GKdG1XVkiDjR8LTkmtvnKuthmRbyBgxaeoSBMwi',
'QmPV8Hp3Ri8965GPLLuHL4htPtgu5p6JXegzAenQrwZQJ4',
'QmV22bm9XJQvyyjyLXSRS3UNNErycUfCCgA3hkchFF2qei',
'QmZz72FPRddhbKDPwJcJjmVybChEcdyzPKKsqpdUHJ5kdE',
'QmWmPhBfvwW1eQkRB7p96xZF7u8PW1H76kxxae9PdXHLdN',
'QmPVVMsXA3giiGsrmC8urZ6rYDv2fWrbMyye27dNC5iYSb',
'QmTJntXVn3Jy9a8hWcb7gYqSouZ9pzxuNBeQJ88AVd5KVC',
'QmWyDJydwQ89FphjgpZj5X4f1N8RSVgj1rscKZyUsJy3mr',
'QmZTJeut8QG9NgbpHEdkKxMjqgQxc1XAvwJ8TxBqLH8Dvm'
];

export const GoldenUris = []